import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ApplicationHistoryTimelineProps } from "../../types/application";
import StatusBadge from "../OtherPage/StatusBadge";

export default function ApplicationHistoryTimeline({ history }: ApplicationHistoryTimelineProps) {
  if (!history || history.length === 0) {
    return <p className="text-xs text-gray-500 italic">No tracking history available.</p>;
  }

  const sortedHistory = [...history].sort(
    (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
  );

  return (
    <div className="relative pl-4 overflow-hidden">
      {/* Connector Line */}
      <div className="absolute left-0 top-2 w-[1px] bg-gray-200 dark:bg-gray-700 h-full"></div>
      
      <div className="space-y-6">
        <AnimatePresence mode="popLayout">
          {sortedHistory.map((item, index) => (
            <motion.div
              key={item.id}
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: index * 0.1 }}
              className="relative flex items-start"
            >
              {/* Dot */}
              <div
                className="absolute -left-[18.5px] top-1.5 w-2.5 h-2.5 rounded-full border-2 border-white dark:border-gray-800 shadow-sm z-10"
                style={{ backgroundColor: item.colorCode }}
              ></div>

              <div className="flex flex-col space-y-1 w-full">
                <div className="flex items-center justify-between gap-4">
                  <div className="flex items-center gap-2">
                    <StatusBadge status={item.status} colorCode={item.colorCode} />
                  </div>
                  
                  <p className="text-[10px] sm:text-xs text-gray-400 dark:text-gray-500 font-mono">
                    {new Date(item.updatedAt).toLocaleString('en-IN', {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit',
                      hour12: true
                    })}
                  </p>
                </div>

                {item.notes && (
                    <motion.div 
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        className="p-2 bg-gray-50 dark:bg-gray-900/50 rounded-md border border-gray-100 dark:border-gray-700 mt-1"
                    >
                        <p className="text-xs text-gray-600 dark:text-gray-400 italic">
                            "{item.notes}"
                        </p>
                    </motion.div>
                )}
              </div>
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </div>
  );
}